import { render } from "./CardItem.vue?vue&type=template&id=5c64f7dc&scoped=true&ts=true"
import script from "./CardItem.vue?vue&type=script&lang=ts"
export * from "./CardItem.vue?vue&type=script&lang=ts"

import "./CardItem.vue?vue&type=style&index=0&id=5c64f7dc&scoped=true&lang=css"

import exportComponent from "/Users/mufeng/Documents/ProjectWorkbench/hotaru_theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c64f7dc"]])

export default __exports__